import {gql} from '@apollo/client';
import {useQuery} from '@apollo/client/react';
import { useAuthContext } from '@/context/AuthContext';
import {useAppSelector} from '@/store/hooks.js';

// Définir la requête GraphQL
const ALL_CV_PROCESSING_QUERY = gql`
  query AllCvProcessing($companyUuid: ID!, $createdAfter: DateTime!) {
    allCvProcessing(cvProcessingRequest: { companyUuid: $companyUuid, createdAfter: $createdAfter }) {
      createdAt
      filename
      status
      uuid
      prospect {
        uuid
        firstname
        lastname
      }
    }
  }
`;

const useAllCvProcessing = (actualDate = null) => {
    const user = useAppSelector((state) => state.auth.currentUser);
    const companyUuid = user.company.uuid;

    // Si actualDate n'est pas fourni, on utilise la date d'hier
    const defaultDate = new Date();
    defaultDate.setHours(defaultDate.getHours() - 24);
    const createdAfter = actualDate || defaultDate.toISOString().replace(/\.\d{3}Z$/, "+00:00");

    const {
        loading: loadingAllCvProcessing,
        error: errorAllCvProcessing,
        data,
        refetch,
    } = useQuery(ALL_CV_PROCESSING_QUERY, {
        variables: { companyUuid, createdAfter },
        fetchPolicy: "network-only",
        skip: !companyUuid,
    });

    return {
        loadingAllCvProcessing,
        errorAllCvProcessing,
        data: data?.allCvProcessing,
        refetch,
    };
};

export default useAllCvProcessing;
